(() => {
  const setup = root => {
    const header = root.querySelector('[data-ur-site-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';
    const legacyHeader = document.querySelector('#site-control');
    const syncCart = () => {
      const source = legacyHeader?.querySelector('.cart:not(.nav-search) > div');
      const target = header.querySelector('.ur-site-cart-count');
      if (source && target) target.textContent = source.textContent.trim();
    };
    if (legacyHeader) new MutationObserver(syncCart).observe(legacyHeader, { childList: true, subtree: true, characterData: true });
    syncCart();
    const menu = header.querySelector('.ur-site-menu');
    const media = window.matchMedia('(max-width:760px)');
    const adjust = () => { menu.open = !media.matches; };
    adjust();
    media.addEventListener('change', adjust);
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const open = event.target.closest(media.matches ? 'details[open]' : '.ur-site-submenu[open]');
      if (open) { open.open = false; open.querySelector('summary').focus(); }
    });
    header.addEventListener('focusout', event => {
      if (!media.matches && !header.contains(event.relatedTarget)) header.querySelectorAll('.ur-site-submenu[open]').forEach(el => { el.open = false; });
    });
    header.addEventListener('toggle', event => {
      if (event.target.matches('.ur-site-submenu[open]')) header.querySelectorAll('.ur-site-submenu[open]').forEach(el => { if (el !== event.target) el.open = false; });
    }, true);
  };
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

(() => {
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !window.matchMedia('(max-width: 767px)').matches || !document.body.matches('.template-collection.template-suffix-no-usf')) return;
    const panel = document.querySelector('.cc-product-filter.-in');
    if (!panel) return;
    const trigger = panel.closest('.cc-product-filter-container')?.querySelector('button[data-show-filter]');
    if (!trigger) return;
    event.preventDefault();
    trigger.click();
    trigger.focus();
  });
})();
